module.exports = __webpack_public_path__ + "img/gallery-image-6.139f99aa.jpg";